
 

 

 

 
class ACLTemplateSearchCriteria 
{
    
        Id: string;
    
        CategoryId: string;
    
        Name: string;
    
        UserUID: string;
    
}
 
export default ACLTemplateSearchCriteria;
 

